<template>
  <j-modal
    :title="title"
    :width="modelStyle.width"
    :visible="visible"
    :bodyStyle ="bodyStyle"
    :switchFullscreen="switchFullscreen"
    @cancel="handleCancel"
    @setInnerFullscreen="setInnerFullscreen"
   >
    <template slot="footer">
       <a-button key="back" @click="handleCancel">{{language['common.closeButton']}}</a-button>
    </template>
    <a-card class="daily-article" :loading="loading">
      <a-card-meta
        :title="record.titile"
        :description="language['announcement.publisher']+'：'+(record.publisher?record.publisher:language['common.not']) +' | '+ language['announcement.publishTime']+'：' + (record.publish_time?record.publish_time:language['common.not'])">
      </a-card-meta>
      <a-divider />
      <span style="margin: 10px 0px">内容标题: <span v-html="record.contentTitle" class="article-content"></span></span>
      <span v-html="record.contentDetails" class="article-content"></span>

    </a-card>
  </j-modal>
</template>

<script>
  import {getAction,putAction} from '@/api/manage'
  export default {
    name: "ShowContent",
    components: {
    },
    data () {
      return {
        title:'内容',
        record: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        visible: false,
        switchFullscreen: true,
        loading: false,
        bodyStyle:{
          padding: "0",
          height:(window.innerHeight*0.65)+"px",
          "overflow-y":"auto",

        },
        modelStyle:{
          width: '60%',
          style: { top: '20px' },
          fullScreen: false
        },
        sysAnnouncementSend:{},
        source:'',
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    created () {
    },
    methods: {
      setInnerFullscreen(val){
        if(val){
          this.bodyStyle.height = (window.innerHeight*0.8)+'px'
        }else{
          this.bodyStyle.height = (window.innerHeight*0.65)+'px'
        }
      },
      Str_msgContent_toHttp(str){
        let windowURL = window._CONFIG['domianURL'];
        if(this.record.msgContent){
          let str = this.record.msgContent;
          return this.funreplace(str,'/*httpurl*/',windowURL);
        }
        return "";
      },
      funreplace(str,string,value){
        str = str.replace(string,value);
        if(str.indexOf(string)!=-1){
          str = this.funreplace(str,string,value)
        }
        return str;
      },
      detail (record,source) {
        this.visible = true;
        this.record = record;
        // this.record.msgContent = this.Str_msgContent_toHttp()
      },

      handleCancel () {
        this.visible = false;
      },
      /** 切换全屏显示 */
      handleClickToggleFullScreen() {
        let mode = !this.modelStyle.fullScreen
        if (mode) {
          this.modelStyle.width = '100%'
          this.modelStyle.style.top = '20px'
        } else {
          this.modelStyle.width = '60%'
          this.modelStyle.style.top = '50px'
        }
        this.modelStyle.fullScreen = mode
      },
      toHandle(){
        if(this.record.openType==='url'){
          this.visible = false;
          //链接跳转
          this.$router.push({path: this.record.openPage})
        }
      },
    }
  }
</script>

<style lang="less">
  .announcementCustomModal{
    .ant-modal-header {
      border: none;
      display: inline-block;
      position: absolute;
      z-index: 1;
      right: 56px;
      padding: 0;
      .ant-modal-title{
        .custom-btn{
          width: 56px;
          height: 56px;
          border: none;
          box-shadow: none;
        }
      }
    }
    .daily-article{
      border-bottom: 0;
    }
  }
</style>
<style scoped lang="less">
  .daily-article {
    .article-button {
      font-size: 1.2rem !important;
    }
    .ant-card-body {
      padding: 18px !important;
    }
    .ant-card-head {
      padding: 0 1rem;
    }
    .ant-card-meta {
      margin-bottom: 1rem;
    }
    .article-content {
      p {
        word-wrap: break-word;
        word-break: break-all;
        text-overflow: initial;
        white-space: normal;
        font-size: .9rem !important;
        margin-bottom: .8rem;
      }
    }
  }
</style>
